import { NgModule } from '@angular/core';
import { TimeDeltaPipe } from './time-delta.pipe';


@NgModule({
    imports: [],
    exports: [TimeDeltaPipe],
    declarations: [TimeDeltaPipe],
    providers: [],
})
export class TimeDeltaPipeModule { }
